import moment from 'moment'

export default ISO8601Date => {
  return ISO8601Date
    ? moment(ISO8601Date).format('MM/DD/YYYY HH:mm:ss')
    : null
}
